import { createUseStyles } from 'react-jss';
import { getSrc } from '~app/helpers/assetLoading';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';
import redHeartGift from '~static/images/red-heart-gift.png';

const useStyles = createUseStyles((theme: CmsWrenchTheme) => ({
  logo: {
    position: 'absolute',
    height: 52,
    width: 266,
    margin: [[50, 0, 0, 50]],
    transition: [['all', '0.2s']],
  },
  wideBackgroundContainer: {
    height: 780,
    background: `linear-gradient(to left, #fff 0%, #fff 76%, #edeeee 39%, #edeeee 100%)`,
  },
  slimBackgroundContainer: {
    height: 1200,
    background: `linear-gradient(to bottom, #fff 0%, #fff 70%, #edeeee 39%, #edeeee 100%)`,
  },
  heroContainer: {
    width: '85%',
    maxWidth: 1440,
  },
  heroCopy: {
    minWidth: 545,
    maxWidth: 660,
  },
  heroHeader: {
    fontWeight: 600,
    fontSize: 64,
    lineHeight: 1.25,
  },
  heroSubHeader: {
    fontSize: 18,
    lineHeight: 1.55,
    width: 561,
  },
  redHeartGift: {
    height: 280,
    minWidth: 280,
    maxWidth: 380,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundImage: `url(${getSrc(redHeartGift)})`,

    '@media (min-width: 577px)': {
      height: 380,
      minWidth: 320,
      maxWidth: 445,
    },

    '@media (min-width: 993px)': {
      minWidth: 428,
      maxWidth: 'none',
    },
  },
  '@media (min-width: 1200px)': {
    heroCopy: {
      marginLeft: -48,
    },
    slimBackgroundContainer: {
      display: 'none',
    },
  },
  '@media (min-width: 1441px)': {
    heroCopy: {
      marginLeft: '6%',
    },
    heroSubHeader: {
      width: '100%',
    },
  },
  '@media (max-width: 992px)': {
    logo: {
      position: 'relative',
      display: 'block',
      margin: [20, 'auto', -48],
      height: 28,
      width: 170,
    },
  },
  '@media (max-width: 768px)': {
    heroHeader: {
      fontSize: 'inherit',
      width: '85%',
      margin: [0, 'auto'],
      display: 'block',
    },
    heroSubHeader: {
      maxWidth: 530,
      fontSize: 'inherit',
      width: '85%',
      margin: [0, 'auto', theme.spacing[2]],
      display: 'block',
    },
    slimBackgroundContainer: {
      height: 861,
    },
  },
  '@media (max-width: 576px)': {
    heroCopy: {
      minWidth: 0,
    },
    heroHeader: {
      fontSize: theme.type.fontSize.pageTitle,
    },
    heroSubHeader: {
      maxWidth: 530,
      display: 'block',
    },
    slimBackgroundContainer: {
      height: 861,
    },
  },
}));

export default useStyles;
